import { Link } from "react-router-dom";
import { Hourglass, ShieldX, ArrowLeft } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import fbnLogo from "@/assets/fbn-logo.png";

interface ApprovalPendingProps {
  variant: "pending" | "declined";
}

export const ApprovalPending = ({ variant }: ApprovalPendingProps) => {
  const { signOut } = useAuth();
  const isDeclined = variant === "declined";

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center">
        <img src={fbnLogo} alt="FBN Entrepreneurs" className="h-12 w-auto mx-auto mb-10" />

        <div
          className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 ${
            isDeclined ? "bg-destructive/10" : "bg-primary/10"
          }`}
        >
          {isDeclined ? (
            <ShieldX className="w-8 h-8 text-destructive" />
          ) : (
            <Hourglass className="w-8 h-8 text-primary" />
          )}
        </div>

        <h1 className="text-3xl font-serif font-semibold text-foreground mb-4">
          {isDeclined ? "Update on your FBN application" : "You're in the queue!"}
        </h1>

        <p className="text-base text-muted-foreground leading-relaxed mb-10">
          {isDeclined
            ? "Thanks for your interest in FBN Entrepreneurs. Unfortunately, we're not able to approve your account at this time. If you think this is a mistake or have questions, please reach out to us."
            : "Thanks for signing up. Your account is being reviewed by our team. You'll receive an email once you're approved — it won't take long."}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          {isDeclined && (
            <Button asChild>
              <Link to="/about">Contact us</Link>
            </Button>
          )}
          <Button variant="outline" onClick={signOut}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            Log out
          </Button>
        </div>
      </div>
    </div>
  );
};